export const ACCOUNT_PASSWORD_MIN_LENGTH = 6;

export const buildAccountEditPayload = (editingAccount = {}) => {
  const payload = {
    companyName:
      editingAccount.clientName ??
      editingAccount.companyName ??
      editingAccount.company_name,
    businessLine: editingAccount.businessLine ?? editingAccount.section,
    region: editingAccount.region,
    company_alias: editingAccount.company_alias ?? editingAccount.alias,
    parkCode: editingAccount.parkCode ?? editingAccount.gzhCode,
    charge_standard: editingAccount.charge_standard,
  };

  const newPassword = String(editingAccount.newPassword ?? '').trim();
  if (newPassword) {
    payload.password = newPassword;
  }

  return payload;
};

export const validateAccountEditForm = (editingAccount = {}) => {
  const newPassword = String(editingAccount.newPassword ?? '').trim();
  if (newPassword && newPassword.length < ACCOUNT_PASSWORD_MIN_LENGTH) {
    return `密码至少 ${ACCOUNT_PASSWORD_MIN_LENGTH} 个字符`;
  }

  return '';
};
